import { useTranslation as useTranslationContext } from "@/context/TranslationContext";

export const useTranslation = () => {
  const { t, isLoading, error, refetch } = useTranslationContext();

  return {
    t,
    isLoading,
    error,
    refetch,
  };
};
